module.exports = __webpack_public_path__ + "img/reporte-min.753ee7a7.png";